import {Component, OnInit} from '@angular/core';
import {FirebaseService} from '../../../../../../service/firebase/firebase.service';
import {take} from 'rxjs/operators';
import {BrWetterbericht} from '../../../../../../model/vorhersagen/br-wetterbericht';

@Component({
  selector: 'app-br',
  templateUrl: './br.component.html',
  styleUrls: ['../wetterbericht.component.css']
})
export class BrComponent implements OnInit {

  brBericht: BrWetterbericht;
  selectedIndex = 0;
  isLoading = true;

  constructor(private firebaseService: FirebaseService) {
  }

  ngOnInit(): void {
    this.loadBerichte();
  }

  private loadBerichte() {
    this.isLoading = true;
    this.firebaseService.getTerminalTexteBR()
      .pipe(take(1))
      .subscribe(querySnapshot => {
        querySnapshot.docs.map(doc => {
          this.brBericht = doc.data();
          this.createListen();
        });
      }, error => {
        console.log(error);
      }).add(() => {
      this.isLoading = false;
    });
  }

  private createListen() {
    this.createRegionenListe();
  }

  private createRegionenListe() {
    this.brBericht.regionalWetterBR.regionsListe = [
      this.brBericht.regionalWetterBR.region_mittelfranken,
      this.brBericht.regionalWetterBR.region_unterfranken,
      this.brBericht.regionalWetterBR.region_niederbayern,
      this.brBericht.regionalWetterBR.region_oberbayern,
      this.brBericht.regionalWetterBR.region_oberfranken,
      this.brBericht.regionalWetterBR.region_oberpfalz,
      this.brBericht.regionalWetterBR.region_schwaben
    ];
  }
}
